// Layout.tsx
import { useEffect } from 'react';
import { Layout, LayoutProps } from 'react-admin';
import { useLocation, useNavigate } from 'react-router-dom';
import CustomSidebar from './CustomSidebar.tsx';
import CustomAppBar from './CustomAppBar.tsx';

const CustomLayout = (props: LayoutProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login', { replace: true });
      return;
    }
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      if (payload.exp && payload.exp * 1000 < Date.now()) {
        localStorage.removeItem('token');
        localStorage.removeItem('userId');
        localStorage.removeItem('roleId');
        localStorage.removeItem('username');
        navigate('/login', { replace: true });
      }
    } catch {
      // Not a standard JWT — accept based on existence alone
    }
  }, [location.pathname, navigate]);

  return (
    <Layout
      {...props}
      sidebar={CustomSidebar}
      appBar={CustomAppBar}
    />
  );
};

export default CustomLayout;
